import * as THREE from "../../libs/three.js/build/three.module.js";

// Foto-daekning (hover-preview, pointcloud.vs): matrix pr. NODE, der foerer et punkts node-lokale `position` direkte over i FOTOETS
// kamerarum (kameraet i origo, kigger langs -Z). Samme princip og begrundelse som clipBoxTransform.js: verden->foto-kamera og
// node'ens modelMatrix har store translationer (UTM-koordinater), saa de ganges her i float64 - resultatet er et lille, lokalt tal
// (node-offset relativt til fotoets kamera), som float32 gengiver uden mærkbart tab. Ingen verdenskoordinater paa GPU'en.
//
// `out` er en Float32Array(16).
const scratch = new THREE.Matrix4();

export function composeCoverageLocalMatrix(photoView, nodeWorld, out){
	scratch.multiplyMatrices(photoView, nodeWorld);
	const e = scratch.elements;
	for(let j = 0; j < 16; j++){
		out[j] = e[j];
	}
	return out;
}
